import React from 'react';
import PropTypes from 'prop-types';
import Navbar from 'components/style/Navbar';
import { RouteUrls } from 'routes/RouteConstants';
import { usePermissions, AppFeaturePermissions } from 'contexts';

const AnalyticsNavbar = ({
    isRankingEnabled,
    isSegmentationEnabled,
    isBalanceSheetOverviewEnabled,
    ...props
}) => {
    const { featurePermissions } = usePermissions();
    const showRanking = featurePermissions?.includes(
        AppFeaturePermissions.Ranking
    );
    const showBalanceSheetOverview = featurePermissions?.includes(
        AppFeaturePermissions.BalanceSheetOverview
    );
    const showFinancialsOverview = featurePermissions?.includes(
        AppFeaturePermissions.FinancialOverview
    );
    const showSegmentation = featurePermissions?.includes(
        AppFeaturePermissions.PortfolioSummary
    );
    return (
        <Navbar
            {...props}
            items={[
                showSegmentation &&
                    isSegmentationEnabled && {
                        title: 'Portfolio Summary',
                        url: RouteUrls.SEGMENTATION,
                    },
                showFinancialsOverview && {
                    title: 'Financial Overview',
                    url: RouteUrls.ANALYTICS_FINANCIAL_OVERVIEW,
                },
                isBalanceSheetOverviewEnabled &&
                    showBalanceSheetOverview && {
                        title: 'Balance Sheet Overview',
                        url: RouteUrls.ANALYTICS_BALANCE_SHEET_OVERVIEW,
                    },
                isRankingEnabled &&
                    showRanking && {
                        title: 'Ranking',
                        url: RouteUrls.ANALYTICS_RANKING,
                    },
            ]}
        />
    );
};

AnalyticsNavbar.propTypes = {
    // NOTE: Read from parent component
    entityType: PropTypes.string.isRequired,
    // NOTE: Read from state
    pureId: PropTypes.string,
    pathName: PropTypes.string,
    isRankingEnabled: PropTypes.bool,
    isSegmentationEnabled: PropTypes.bool,
    isBalanceSheetOverviewEnabled: PropTypes.bool,
    isProperty: PropTypes.bool,
    isPortfolioID: PropTypes.bool,
};

export default AnalyticsNavbar;
